export default class InputView {
  constructor(placeholder) {
    this.placeholder = placeholder;
  }

  render() {
    const header = document.createElement('header');
    header.innerHTML = `<form class="search-form">
    <input class="search-form__input" type="text" placeholder="${this.placeholder}">
    <button class="search-form__button red-stylized-button" type='button'>Search</button>
    </form>`;
    document.body.appendChild(header);
  }
}
